module.exports = __webpack_public_path__ + "static/media/caret_single.fc847157.svg";